import { getTvObject, tv } from '@costar-ui/cosmos';
import { focusRing } from '../../../theme/styles/common.esm.js';

var segmentOptionTvObject = getTvObject({
  extend: focusRing,
  base: ['csg-tw-segment', 'rounded-sm', 'p-2', 'relative', 'border-action-neutral', 'flex', 'gap-1', 'w-full', 'justify-center', focusRing.base],
  variants: {
    isFocusVisible: {
      "false": focusRing.variants.isFocusVisible["false"],
      "true": focusRing.variants.isFocusVisible["true"]
    },
    isHovered: {
      "true": 'bg-action-base-hover text-on-action-base-hover' //Subject to change
    },
    isSelected: {
      "true": 'border-selected bg-action-selected text-on-action-selected' //Subject to change
    },
    isDisabled: {
      "true": 'border-disabled bg-action-disabled text-on-action-disabled' //Subject to change
    },
    size: {
      xl: ['px-5', 'py-3', 'h-11'],
      std: ['p-2', 'h-8', 'text-p-16'],
      sm: ['py-1', 'px-1.5', 'h-6', 'text-p-14']
    }
  },
  compoundVariants: [{
    isSelected: true,
    isDisabled: true,
    className: 'border-disabled bg-action-disabled'
  }]
});
var segmentOptionStyles = tv(segmentOptionTvObject);

export { segmentOptionStyles, segmentOptionTvObject };
//# sourceMappingURL=segment-option.styles.esm.js.map
